import { createAsyncThunk } from '@reduxjs/toolkit'

//utils
import { getFullName } from '../../../utils'

import { getStatus } from '../../api/status'
import { getPettyCashCategories } from "../../api/pettyCashCategoties"
import { getMaterialBrandsData } from '../../api/materialBrand'
import { getMaterialUomsData } from '../../api/materialUom'
import { getMaterialCategoriesData } from '../../api/materialCategory'
import { allCountryList } from '../../api/country'
import { getCurriencesData } from '../../api/currency'
import { getMaterialIdTypesData } from '../../api/materialIdType'
import { getCompanyTypesData } from '../../api/companyType'
import { getCompanySupplyTypesData } from '../../api/companySupplyType'
import { getCompanySizeCategoriesData } from '../../api/companySizeCategory'
import { getCompanyBusinessTypesData } from '../../api/companyBusinessType'
import { getCompanyCreditPeriodsData } from '../../api/companyCreditPeriod'
import { getDocTypesData } from '../../api/docTypes'
import { getOrderTypesData } from '../../api/orderTypes'
import { getMaterialSpecificationMandatoryTypes } from '../../api/materialSpecificationMandatoryTypes'
import { getMaterialIdTeamData } from '../../api/materialIdTeam'
import { getStatesData } from '../../api/state'
import { sortArrayOfObjectsInAlphabeticalOrder } from '../../../utils'
import { getHsnMastersData } from '../../api/hsnMaster'
import { getChequeBooks } from '../../api/chequeBooks'
import { getCompanyBankAccounts } from '../../api/companyBankAccount'
import { getTDSSections } from '../../api/tdsSections'
import { getTicketCategories, getTicketSubCategories, getTicketStatuses, getTicketGroupAssignees, getTicketSubCategoryParams, getTicketConstraintAssignees, getTicketConstraintCategories, getTicketDetailedStatus, getLastcommentStructures } from '../../api/tickets'
import { getPinCodes } from '../../api/pinCodes'
import { getUserRolesByCompanyId, getClientSuccessManagers, getBuyerCompaniesUsers } from '../../api/user'
import { getApprovals } from '../../api/approvals'
import { getCompanyWarehousesData } from '../../api/companyWarehouses'
import { getLogisticsPartners } from '../../api/logistcsPartners'
import { getStockMoveTypesData } from '../../api/stockMoveTypes'
import { getApprovalTypes } from '../../api/approvalTypes'
import { getGstRatesData } from '../../api/gstRate'
import { getIncoTerms } from '../../api/incoTerms'
import {getPoRescheduleReasonList} from '../../api/poPunch'
import { getBuyerQuoteClosureReasonList } from '../../api/buyerQuote'
import { getPMBranches } from '../../api/pmBranch'
import { getApprovalSecondaries } from '../../api/approvalSecondary'
import { getHolidayCalendar } from '../../api/holidayCalendar'
import { getBuyerCompanies } from '../../api/company'
import { getFollowUpStatusData } from '../../api/followUpStatus'
import { getDeliveryStatusData } from '../../api/deliveryStatus'
import { getVendorRCTypes } from '../../api/vendorRCTypes'
import { getVendorRCCoverageTypes } from '../../api/vendorRCCoverageTypes'
import { getCompanyRoleHierarchy } from '../../api/companyRoleHierarchy'
import { getCompanyMSMEDTypes } from '../../api/companyMSMEDTypes'
import { getVMIQtyTypes } from '../../api/vmiQtyTypes'
import { getNotificationTypes } from '../../api/notificationTypes'
import { getPriorities } from '../../api/priority'
import { getOpsEditableMaterialsData } from '../../api/opsEditableMaterials'
import { getMaterialSpecifications } from '../../api/materialSpecifications'
import { getQuoteClasses } from '../../api/quoteClasses'
import { getSkipSuggMarginReasons } from '../../api/skipSuggMarginReasons'
import { getAdjustmentReasons } from '../../api/adjustmentReasons'
import { getVendorRateContracts } from '../../api/vendorRateContract'
import { getCompanyTags } from '../../api/companyTags'

export const fetchStatus = createAsyncThunk('common/getStatus', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.status.length > 0) {
            return existingData.status
        }
    }

    const response = await getStatus({paginator: false})
    //const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response.data, "status")
    return response.data.data
})

export const fetchIncoTerms = createAsyncThunk('common/getIncoTerms', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.incoTerms.length > 0) {
            return existingData.incoTerms
        }
    }

    const response = await getIncoTerms()
    return response.data
})

export const fetchPettyCashCategories = createAsyncThunk('common/getPettyCashCatergoires', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.pettycashCategories.length > 0) {
            return existingData.pettycashCategories 
        }
    }
    
    const response = await getPettyCashCategories({paginator: false})
    return response.data
})

export const fetchMaterialBrands = createAsyncThunk('common/getMaterialBrands', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.materialBrands.length > 0) {
            return existingData.materialBrands
        }
    }

    const materialBrandsParams = { sortBy: 'brandName', paginator: false, sortOrder: 'ASC' }  //{ recordsPerPage: 4000, sortBy: 'brandName' }
    const response = await getMaterialBrandsData(materialBrandsParams)
    return response.data.data
})

export const fetchMaterialUoms = createAsyncThunk('common/getMaterialUoms', async (useCache, { getState }) => {
    // console.log("fetchMaterialUoms", useCache)
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.materialUOMs.length > 0) {
            return  existingData.materialUOMs
        }
    }

    const materialUOMParams = { recordsPerPage: 100, sortBy: 'UOM', paginator: false }
    const response = await getMaterialUomsData(materialUOMParams)
    return response.data.data
})

export const fetchCountries = createAsyncThunk('common/getCountries', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.countries.length > 0) {
            return  existingData.countries
        }
    }

    const response = await allCountryList({paginator: false})
    return response.data.data
})

export const fetchCurriences = createAsyncThunk('common/getCurrenies', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.currencies.length > 0) {
            return existingData.currencies
        }
    }

    const response = await getCurriencesData({paginator: false})
    return response.data.data
})

export const fetchMaterialIdTypes = createAsyncThunk('common/getMaterialIdTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.materialIdTypes.length > 0) {
            return existingData.materialIdTypes
        }
    }

    const response = await getMaterialIdTypesData({paginator: false})
    return response.data.data
})

export const fetchCompanyTypes = createAsyncThunk('common/getCompanyTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.companyTypes.length > 0) {
            return  existingData.companyTypes
        }
    }

    const response = await getCompanyTypesData({paginator: false})
    // const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response.data, "seq")
    return response.data.data
})

export const fetchCompanySupplyType = createAsyncThunk('common/getCompanySupplyType', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companySupplyType.length > 0) {
            
            return  existingData.companySupplyType
        }
    }

    const response = await getCompanySupplyTypesData({paginator: false})
    const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response.data.data, "seq ")
    return sortedAlphabaticalData
})

export const fetchCompanySizeCategory = createAsyncThunk('common/getCompanySizeCategory', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companySizeCategories.length > 0) {
            return existingData.companySizeCategories
        }
    }

    const response = await getCompanySizeCategoriesData({paginator: false})
    // const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response.data.data, "seq")
    return response.data.data
})

export const fetchCompanyBusinessTypes = createAsyncThunk('common/getCompanyBusinessTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companyBusinessTypes.length > 0) {
            return  existingData.companyBusinessTypes
        }
    }

    const response = await getCompanyBusinessTypesData({paginator: false})
    // console.log("Resssssssssssss", response)
    // const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response.data, "seq")
    return response.data.data
})

export const fetchCompanyCreditPeriods = createAsyncThunk('common/getCompanyCreditPeriodsData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companyCreditPeriods.length > 0) { 
            return  existingData.companyCreditPeriods
        }
    }

    const response = await getCompanyCreditPeriodsData({sortOrder:"ASC", paginator: false})
    // console.log('in thunk', response)
    return response.data.data
})

export const fetchDocTypesData = createAsyncThunk('common/getDocTypesData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.docTypes.length > 0) {
            return  existingData.docTypes
        }
    }

    const response = await getDocTypesData({paginator: false})
    return response.data
})

export const fetchOrderTypesData = createAsyncThunk('common/getOrderTypesData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.orderTypes.length > 0) {
            return existingData.orderTypes
        }
    }

    const response = await getOrderTypesData({paginator: false})
    const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response.data, "orderType")
    return sortedAlphabaticalData
})

export const fetchStates = createAsyncThunk('common/getStatesData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.states.length > 0) {
            return existingData.states
        }
    }

    const response = await getStatesData({ paginator: false })
    return response.data.data
})

export const fetchMaterialCategories = createAsyncThunk('common/getMaterialCategoriesData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.materialCategories.length > 0) {
            return  existingData.materialCategories
        }
    }

    const materialCategoriesParams = { sortBy: 'categoryName', sortOrder: "ASC", paginator: false }
    const response = await getMaterialCategoriesData(materialCategoriesParams)
    return response.data.data
})

export const fetchMaterialSpecificationMandatoryTypes = createAsyncThunk('common/getMaterialSpecificationMandatoryTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.materialSpecificationMandatoryTypes.length > 0) {
            return existingData.materialSpecificationMandatoryTypes
        }
    }

    const response = await getMaterialSpecificationMandatoryTypes({paginator: false})
    return response.data
})

export const fetchMaterialIdTeam = createAsyncThunk('common/getMaterialIdTeam', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.materialIdTeam.length > 0) {
            return existingData.materialIdTeam
        }
    }

    const response = await getMaterialIdTeamData({paginator: false})
    return response.data
})

export const fetchHSNMasterData = createAsyncThunk('common/getHsnMasters', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.HSNMaster.length > 0) {
            return existingData.HSNMaster
        }
    }

    const response = await getHsnMastersData()
    return response.data
})

export const fetchChequeBooks = createAsyncThunk('common/getChequeBooks', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.chequeBooks.length > 0) {
            return existingData.chequeBooks
        }
    }

    const response = await getChequeBooks({paginator: false})
    return response.data
})

export const fetchBankDetails = createAsyncThunk('common/getBankDetails', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.bankDetails.length > 0) {
            return {
                data: existingData.bankDetails
            }
        }
    }

    const response = await getCompanyBankAccounts({companyId: 1})
    return response.data
})

export const fetchTDSSections = createAsyncThunk('common/getTDSSections', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.tdsSections.length > 0) {
            return  existingData.tdsSections
        }
    }

    const response = await getTDSSections()
    
    return response?.data?.data
})

export const fetchTicketCategory = createAsyncThunk('common/getTicketCategories', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.ticketCategories.length > 0) {
            return existingData.ticketCategories
        }
    }

    const response = await getTicketCategories()
    return response.data
})

export const fetchTicketSubCategory = createAsyncThunk('common/getTicketSubCategories', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.ticketSubCategories.length > 0) {
            return existingData.ticketSubCategories
        }
    }

    const response = await getTicketSubCategories()
    return response.data
})

export const fetchTicketStatus = createAsyncThunk('common/getTicketStatus', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.ticketStatus.length > 0) {
            return existingData.ticketStatus
        }
    }

    const response = await getTicketStatuses()
    return response.data
    
})


export const fetchPinCodes = createAsyncThunk('common/getPinCodes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.pinCodes.length > 0) {
            return  existingData.pinCodes
        }
    }

    const response = await getPinCodes()
    return response.data
})

export const fetchUserListByCompanyId = createAsyncThunk('common/getUserRolesByCompanyId', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData?.userList.length > 0) {
            return {
                data: existingData.userList
            }
        }
    }
    const data = { companyId: 1 }
    const response = await getUserRolesByCompanyId(data)
    return response
})

export const fetchApprovalTypes = createAsyncThunk('common/approvalTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData?.approvalTypes.length > 0) {
            return  { data: existingData.approvalTypes }
        }
    }

    const response = await getApprovalTypes({paginator: false})
    return response
})

export const fetchApprovals = createAsyncThunk('common/approvals', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.approvals.length > 0) {
            return  existingData.approvals
        }
    }

    const response = await getApprovals({paginator: false})
    return response
})

export const fetchApprovalSecondary = createAsyncThunk('common/approvalSecondary', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.approvalSecondary.length > 0) {
            return existingData.approvalSecondary
        }
    }
    
    const response = await getApprovalSecondaries({paginator: false})
    return response.data
})

export const fetchCompanyWarehouses = createAsyncThunk('common/companyWarehouses', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companyWarehouses.length > 0) {
            return existingData.companyWarehouses
        }
    }

    const response = await getCompanyWarehousesData({sortBy: 'warehouseName', sortOrder: "ASC", paginator: false})
    return response.data.data
})

export const fetchLogisticPartners = createAsyncThunk('common/logisticPartners', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.logisticPartners.length > 0) {
            return  existingData.logisticPartners
        }
    }

    const response = await getLogisticsPartners({sortBy: 'partnerName', paginator: false})
    return response.data.data
})

export const fetchStockMoveTypes = createAsyncThunk('common/getStockMoveTypesData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.stockMoveTypes.length > 0) {
            return  existingData.stockMoveTypes
        }
    }

    const stockMoveTypeParams = { sortBy: 'stockMoveType', sortOrder: "ASC", paginator: false }
    const response = await getStockMoveTypesData(stockMoveTypeParams)
    return response.data.data
})

export const fetchPMBranches = createAsyncThunk('common/getPMBranches', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.PMBranches.length > 0) {
            return  existingData.PMBranches
        }
    }

    const response = await getPMBranches()
    return response.data
})

export const fetchGSTRates = createAsyncThunk('common/getGstRates', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.GSTRates.length > 0) {
            return  existingData.GSTRates
        }
    }

    const gstRateParams = { sortBy: 'GSTRate', sortOrder: "ASC", paginator: false }
    const response = await getGstRatesData(gstRateParams)
    return response?.data?.data
})

export const fetchTicketGroupAssignee = createAsyncThunk('common/getTicketGroupAssignee', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.ticketGroupAssignee.length > 0) {
            console.log("existing ticketGroupAssignee", existingData.ticketGroupAssignee)
            return existingData.ticketGroupAssignee
        }
    }

    const response = await getTicketGroupAssignees()
    console.log("ticketGroupAssignee response", response)
    return response.data
})

export const fetchTicketSubCategoryParams = createAsyncThunk('common/getTicketSubCategoryParams', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.ticketSubCategoryParams.length > 0) {
            return existingData.ticketSubCategoryParams
        }
    }

    const response = await getTicketSubCategoryParams()
    return response.data
})

export const fetchTicketConstraintAssignees = createAsyncThunk('common/getTicketConstraintAssignees', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.ticketConstraintAssignees.length > 0) {
            return existingData.ticketConstraintAssignees
        }
    }

    const response = await getTicketConstraintAssignees()
    return response.data
})

export const fetchTicketConstraintCategories = createAsyncThunk('common/getTicketConstraintCategories', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData.ticketConstraintCategories.length > 0) {
            return existingData.ticketConstraintCategories
        }
    }

    const response = await getTicketConstraintCategories()
    return response.data
})

export const fetchPoRescheduleReasonList = createAsyncThunk('common/getPoRescheduleReasonList', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.poRescheduleReasonList.length > 0) {
            return existingData.poRescheduleReasonList
        }
    }
    const response = await getPoRescheduleReasonList()
    console.log("fetchPoRescheduleReasonList", response.data)
    return response.data
})

export const fetchBuyerQuoteClosureReasonList = createAsyncThunk('common/getBuyerQuoteClosureReasonList', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.buyerQuoteClosureReasonList.length > 0) {
            console.log("fetchBuyerQuoteClosureReasonList existing", existingData?.buyerQuoteClosureReasonList)
            return existingData.buyerQuoteClosureReasonList
        }
    }
    const response = await getBuyerQuoteClosureReasonList()
    console.log("fetchBuyerQuoteClosureReasonList", response.data)
    return response.data
})

export const fetchClientSuccessManagers = createAsyncThunk('common/getClientSuccessManagers', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.clientSuccessManagers.length > 0) {
            return existingData.clientSuccessManagers
        }
    }

    const response = await getClientSuccessManagers({ paginator: false })

    let updatedClientSuccessManagers = []
    if(response?.data?.length > 0){
        updatedClientSuccessManagers = response?.data.map(eachUser => {
            return {...eachUser, fullName: getFullName(eachUser.firstName, eachUser.lastName)}
        })
    }
    
    return updatedClientSuccessManagers
})

export const fetchCalendarHolidays = createAsyncThunk('common/getHolidayCalendar', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.calendarHolidays.length > 0) {
            return existingData.calendarHolidays
        }
    }

    const response = await getHolidayCalendar()
    return response.data
})

export const fetchBuyerCompaniesUsers = createAsyncThunk('common/getBuyerCompaniesUsers', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.buyerCompaniesUsers.length > 0) {
            return existingData.buyerCompaniesUsers
        }
    }

    const response = await getBuyerCompaniesUsers()
    // console.log("response", response)
    let updatedBuyerCompaniesUsers = []
    if(response?.data?.length > 0){
        updatedBuyerCompaniesUsers = response?.data.map(eachUser => {
            return {...eachUser, fullName: getFullName(eachUser.firstName, eachUser.lastName)}
        })
    }
    
    return updatedBuyerCompaniesUsers
})

export const fetchBuyerCompanies = createAsyncThunk('common/getBuyerCompanies', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.buyerCompanies.length > 0) {
            return existingData.buyerCompanies
        }
    }

    const response = await getBuyerCompanies()
    return response.data.data
})

export const fetchFollowUpStatusData = createAsyncThunk('common/getFollowUpStatusData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.followUpStatus.length > 0) {
            return existingData.followUpStatus
        }
    }

    const response = await getFollowUpStatusData({paginator: false})
    const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response?.data.data, "followUpStatusName")
    return sortedAlphabaticalData
})

export const fetchDeliveryStatusData = createAsyncThunk('common/getDeliveryStatusData', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.deliveryStatus.length > 0) {
            return existingData.deliveryStatus
        }
    }

    const response = await getDeliveryStatusData({paginator: false})
    const sortedAlphabaticalData = sortArrayOfObjectsInAlphabeticalOrder(response?.data.data, "deliveryStatusName")
    return sortedAlphabaticalData
})

export const fetchTicketDetailedStatus = createAsyncThunk('common/getTicketDetailedStatus', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.ticketDetailedStatus.length > 0) {
            return existingData.ticketDetailedStatus
        }
    }

    const response = await getTicketDetailedStatus()
    console.log("ticketDetailedStatus response", response)
    return response.data
})

export const fetchLastCommentStructures = createAsyncThunk('common/getLastcommentStructures', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.lastCommentStructures.length > 0) {
            return existingData.lastCommentStructures
        }
    }

    const response = await getLastcommentStructures()
    return response.data
})

export const fetchVendorRCTypes = createAsyncThunk('common/getVendorRCTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.vendorRCTypes.length > 0) {
            return existingData.vendorRCTypes
        }
    }

    const response = await getVendorRCTypes()
    return response
})

export const fetchVendorRCCoverageTypes = createAsyncThunk('common/getVendorRCCoverageTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.vendorRCCoverageTypes.length > 0) {
            return existingData.vendorRCCoverageTypes
        }
    }

    const response = await getVendorRCCoverageTypes()
    return response
})

export const fetchCompanyRoleHierarchyData = createAsyncThunk('common/getCompanyRoleHierarchy', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companyRoleHierarchy.length > 0) {
            return existingData.companyRoleHierarchy
        }
    }

    const response = await getCompanyRoleHierarchy({paginator: false})
    return response.data.data
})

export const fetchVMIQtyTypes = createAsyncThunk('common/VMIQtyTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData?.vmiQtyTypes.length > 0) {
            return existingData.lastCommentStructures
        }
    }

    const response = await getVMIQtyTypes()
    return response.data.data
})

export const fetchNotificationTypes = createAsyncThunk('common/getNotificationTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData?.notificationTypes.length > 0) {
            return existingData.notificationTypes
        }
    }

    const response = await getNotificationTypes()
    return response.data
})

export const fetchPriorities = createAsyncThunk('common/getPriorities', async (useCache, { getState }) => {
    if (useCache !== false) {
        const existingData = getState().common
        if (existingData?.priorities?.length > 0) {
            return existingData.priorities
        }
    }

    const response = await getPriorities()
    return response.data
})
export const fetchCompanyMSMEDTypes = createAsyncThunk('common/getCompanyMSMEDTypes', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companyMSMEDTypes.length > 0) {
            return  existingData.companyMSMEDTypes
        }
    }

    const companyMSMEDTypesParams = { sortBy: 'companyMSMEDType', sortOrder: "ASC", paginator: false }
    const response = await getCompanyMSMEDTypes(companyMSMEDTypesParams)
    return response.data.data
})

export const fetchOpsEditableMaterials = createAsyncThunk('common/opsEditableMaterials', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.opsEditableMaterials > 0) {
            return existingData.opsEditableMaterials
        }
    }

    const response = await getOpsEditableMaterialsData()
    return response.data
})

export const fetchMaterialSpecifications = createAsyncThunk('common/materialSpecifications', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.materialSpecifications > 0) {
            return existingData.materialSpecifications
        }
    }

    const response = await getMaterialSpecifications({paginator: false})
    return response.data.data
})

export const fetchQuoteClasses = createAsyncThunk('common/quoteClasses', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.quoteClasses > 0) {
            return existingData.quoteClasses
        }
    }

    const response = await getQuoteClasses()
    return response
})

export const fetchSkipSuggMarginReasons = createAsyncThunk('common/skipSuggMarginReasons', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.skipSuggMarginReasons > 0) {
            return existingData.skipSuggMarginReasons
        }
    }

    const response = await getSkipSuggMarginReasons()
    return response.data
})

export const fetchAdjustmentReasons = createAsyncThunk('common/adjustmentReasons', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.adjustmentReasons.length > 0) {
            return  existingData.adjustmentReasons
        }
    }

    const response = await getAdjustmentReasons({paginator: false})
    return response.data.data
}) 

export const fetchVendorRateContracts = createAsyncThunk('common/vendorRateContracts', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common
        if (existingData.vendorRateContracts > 0) {
            return existingData.vendorRateContracts
        }
    }

    const response = await getVendorRateContracts()
    return response
})

export const fetchCompanyTags = createAsyncThunk('common/getCompanyTags', async (useCache, { getState }) => {
    if(useCache !== false){
        const existingData = getState().common

        if (existingData?.companyTags.length > 0) {
            return existingData.companyTags
        }
    }

    const response = await getCompanyTags()
    return response.data
})
